import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Text, Button } from 'roo-ui/components';
import { useDataLayer } from 'hooks/useDataLayer';
import ErrorHeading from 'pages/Checkout/BookingErrorDialogs/ErrorHeading';

const RoomUnavailableDialog = ({ propertyName }) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleOnClick = useCallback(() => {
    emitInteractionEvent({ type: 'Change Your Selection', value: 'Link Clicked' });
    window.history.back();
  }, [emitInteractionEvent]);

  return (
    <Wrapper>
      <ErrorHeading>Sorry, your selection is no longer available</ErrorHeading>
      <Text display="block" mb={6}>
        {propertyName
          ? `Please change your selection at ${propertyName} to continue with your booking.`
          : 'Please change your selection to continue with your booking.'}
      </Text>
      <Button variant="primary" width={['100%', 'auto']} onClick={handleOnClick}>
        Change Selection
      </Button>
    </Wrapper>
  );
};

RoomUnavailableDialog.propTypes = {
  propertyName: PropTypes.string,
};

RoomUnavailableDialog.defaultProps = {
  propertyName: 'room',
};

export default RoomUnavailableDialog;
